<template>
  <widget-template title="Revenue Chart">
    <div slot="title">
      <div>
        <div class="headline">Total Revenue Chart</div>
        <span class="grey--text">{{revenueChart.info}}</span>
      </div>
    </div>
    <div slot="action">
      <div v-if="initState === 0">
        <v-tooltip bottom>
          <span slot="activator" class="grey--text">
            <v-icon small color="orange">mdi-record</v-icon>
            Loading...
          </span>
          <span>Loading</span>
        </v-tooltip>
      </div>
      <div v-else-if="initState === 1">
        <v-tooltip bottom>
          <div slot="activator" @click="doReload" class="widgetAction grey--text">
            <v-icon small>mdi-refresh</v-icon>
            Updated {{lastUpdated}} ago
          </div>
          <span>Click to update</span>
        </v-tooltip>
      </div>
      <div v-else>
        <v-tooltip bottom>
          <span slot="activator" @click="doReload" class="widgetAction grey--text">
            <v-icon small color="red">mdi-record</v-icon>
            Error
          </span>
          <span>Click to retry</span>
        </v-tooltip>
      </div>
    </div>
    <div>
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <div slot="activator">
            <v-tooltip top>
              <v-layout align-center slot="activator">
                <v-icon>mdi-calendar-today</v-icon> {{selectedScope.description}}
              </v-layout>
              <span>{{selectedScope.info}}</span>
            </v-tooltip>
          </div>
          <v-list>
            <v-list-tile v-for="(option, key) in scopes" :key="key" @click="doSelectScope(key)">
              <v-list-tile-title>{{ option.description }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </span>
      |
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <div slot="activator">
            <v-tooltip top>
              <v-layout align-center slot="activator">
                <v-icon>mdi-view-grid</v-icon> {{selectedAppId.description}}
              </v-layout>
              <span>
                {{permittedAppIdsText}}
              </span>
            </v-tooltip>
          </div>
          <v-list>
            <v-list-tile v-for="(appId, index) in appIds" :key="index" @click="doSelectAppId(appId.id)">
              <v-list-tile-title>{{ appId.description }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </span>
      |
      <span class="pr-2 pl-2">
        <div class="v-menu v-menu--inline widgetAction" @click="exportChart">
          <v-tooltip top>
            <v-layout align-center slot="activator">
              <v-icon>mdi-export</v-icon> Export
            </v-layout>
            <span>
              Save as image
            </span>
          </v-tooltip>
        </div>
      </span>
    </div>
    <div class="mt-4" style="position: relative;">
      <bar-chart :chart-data="chartData" :options="chartOptions" ref="chart"></bar-chart>
    </div>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { longScopeMixin } from '../longScopeMixin'
import { chartMixin } from '../chartMixin'

export default {
  data() {
    return {
      widgetForm: {
        scope: 'days',
        appId: 'all'
      },
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  watch: {
    'revenueChart.chartInfo': function (value) {
      this.compileData(value)
    }
  },
  computed: {
    revenueChart() {
      return this.$store.state.widgets.revenueChart
    },
    initState() {
      return this.revenueChart.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.revenueChart.lastUpdated, this.timeNow)
    },
    permittedAppIdsText() {
      return this.formatPermitAppIdsText(this.revenueChart.appIds)
    }
  },
  methods: {
    ...mapActions([
      'initRevenueChart'
    ]),
    doReload() {
      // Combine Form
      this.widgetForm.scope = this.scopeForm.scope
      this.widgetForm.appId = this.appIdForm.appId
      this.initRevenueChart(this.widgetForm)
    },
    compileData(value) {
      // Reset data
      this.chartData = {
        labels: [],
        datasets: []
      }
      let subData = []
      if (value && value.length > 0) {
        value.forEach(chartInfo => {
          this.chartData.labels.push(chartInfo.label)
          subData.push(chartInfo.revenue)
        })
      }
      this.chartData.datasets.push({
        label: 'Revenue',
        backgroundColor: '#959de9',
        borderColor: '#1a237e',
        borderWidth: 1,
        data: subData
      })
    }
  },
  mounted() {
    if (this.initState !== 1) {
      // Default values
      this.doSelectScope('days', false)
      this.doSelectAppId('all')
    } else {
      // Doesnt want to do auto refresh here (save bandwidth, let user do it manually)
      if (this.revenueChart.scope) {
        this.doSelectScope(this.revenueChart.scope, false)
      }
      if (this.revenueChart.appId) {
        this.doSelectAppId(this.revenueChart.appId, false)
      }
      // compile data
      this.compileData(this.revenueChart.chartInfo)
    }
  },
  mixins: [
    longScopeMixin(),
    chartMixin
  ],
  components: {
    // Async loading (lazy load)
    'bar-chart': () => import('@/components/reusable/charts/BarChart')
  }
}
</script>

<style lang="scss" scoped>
</style>
